import {createSelector} from 'reselect'
import {selectErrorState} from '../../app/selectors'
import {ErrorState} from './error.types'

export const selectErrorMessage = createSelector(selectErrorState, (state: ErrorState) => state.message)
export const selectErrorType = createSelector(selectErrorState, (state: ErrorState) => state.type)
export const selectErrorTimestamp = createSelector(selectErrorState, (state: ErrorState) => state.timestamp)
